import { render } from "./ImportOverview.vue?vue&type=template&id=5052e7c9&ts=true"
import script from "./ImportOverview.vue?vue&type=script&lang=ts"
export * from "./ImportOverview.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__